import { OrganizationMemberFromContext } from '~/core/context/organization/hooks/useOrganizationMembers'
import { AppSessionType } from '~/features/appSession/common'

const getName = (member: OrganizationMemberFromContext) => {
  const appSession = member?.appSession as AppSessionType
  const user = member?.user
  return (
    appSession?.name ??
    appSession?.values?.agent?.name ??
    user?.name ??
    'Unknown'
  )
}

const getPictureUrl = (member: OrganizationMemberFromContext) => {
  const appSession = member?.appSession as AppSessionType
  const user = member?.user
  return (
    appSession?.pictureUrl ??
    appSession?.values?.agent?.pictureUrl ??
    user?.pictureUrl
  )
}

const getRole = (member: OrganizationMemberFromContext) => {
  const appSession = member?.appSession as AppSessionType
  return appSession?.role ?? appSession?.values?.agent?.role
}

export const Helper = {
  getName,
  getRole,
  getPictureUrl,
}
